module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "ايون"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ايون")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "Center"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اسمها نورة.. يمكنك أن تدعوها \"أيون\"."), _c('br'), _vm._v("هي بشريَّةٌ أَحَبَّتْ كونها")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مُظلمة ومعتمة، وهذا ما جعلها جميلة.\n")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "Center",
      "directon": "rtl"
    }
  }, [_c('span', [_vm._v("\nأتُريد أن تعلم ما الذي يجعلها أفضل؟ لأنَّها تقبَّلَتِ اختلافها.لذا تريد أن تخُطَّ بعض الكلمات بسوادها، وتُعيرَك إيَّاها.\n\n\n\n")])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "direction": "ltr"
    }
  }, [_vm._v("The author's name is Noura but she likes to be called iON.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "direction": "ltr"
    }
  }, [_vm._v("She is a human who loves being dark.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "direction": "ltr"
    }
  }, [_vm._v("That's what makes her beautiful. And do you know what makes it better? That she has accepted who she is.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "direction": "ltr"
    }
  }, [_vm._v("Now she wants to turn her gloom into words so you can borrow them.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("******")]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فتاة آمنَت دائمًا أنَّه كَون الشَّخص مُظلِمًا لا يعني بأنَّه لا يمتلك الأحقيَّة في التميُّز، وذلك بحدِّ ذاته ما ميَّزَها.")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لذا بدأَت في الكتابة لإخبار الجميع أنَّ الاختلاف لا يعني النهاية، بل بداية تاريخٍ آخَر.ثقَّفَت نفسها، وأبرَزَت حروفها.. رسمَت وأنجزَت، وها هي تبدأ مسيرتها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ab9d586","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch002.vue
// module id = 63
// module chunks = 0